import styled from 'styled-components'
import List from '@pc/components/Works/Panel/shared/list/List'

const ModalList = styled(List)`
  height: 100%;
  width: 100%;
`

export default ModalList
